var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3569_13345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.7666 14.7949C6.79827 14.7949 5.88827 14.6111 5.0366 14.2433C4.18494 13.8756 3.4441 13.377 2.8141 12.7474C2.1841 12.1174 1.68547 11.3766 1.3182 10.5249C0.950935 9.67325 0.767068 8.76325 0.766602 7.79492C0.766602 6.82659 0.950468 5.91659 1.3182 5.06492C1.68593 4.21326 2.18457 3.47242 2.8141 2.84242C3.4441 2.21242 4.18494 1.71379 5.0366 1.34652C5.88827 0.979255 6.79827 0.795389 7.7666 0.794922C8.52493 0.794922 9.24243 0.905755 9.9191 1.12742C10.5958 1.34909 11.2199 1.65826 11.7916 2.05492L10.7766 3.08742C10.3333 2.80742 9.86077 2.58879 9.3591 2.43152C8.85743 2.27425 8.3266 2.19539 7.7666 2.19492C6.21493 2.19492 4.89357 2.74045 3.8025 3.83152C2.71143 4.92259 2.16613 6.24372 2.1666 7.79492C2.1666 9.34659 2.71213 10.668 3.8032 11.759C4.89427 12.8501 6.2154 13.3954 7.7666 13.3949C9.31827 13.3949 10.6396 12.8496 11.7307 11.759C12.8218 10.6684 13.3671 9.34705 13.3666 7.79492C13.3666 7.58492 13.3549 7.37492 13.3316 7.16492C13.3083 6.95492 13.2733 6.75075 13.2266 6.55242L14.3641 5.41492C14.4924 5.78826 14.5916 6.17325 14.6616 6.56992C14.7316 6.96659 14.7666 7.37492 14.7666 7.79492C14.7666 8.76325 14.5827 9.67325 14.215 10.5249C13.8473 11.3766 13.3486 12.1174 12.7191 12.7474C12.0891 13.3774 11.3483 13.8763 10.4966 14.244C9.64493 14.6118 8.73493 14.7954 7.7666 14.7949ZM6.7866 11.0149L3.8116 8.03992L4.7916 7.05992L6.7866 9.05492L13.7866 2.03742L14.7666 3.01742L6.7866 11.0149Z",
    fill: "#7E8CA8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3569_13345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.766602 0.794922)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskCheck);
export default __webpack_public_path__ + "static/media/task-check.020e3a7ba60fb6418bae2cd8953e778a.svg";
export { ForwardRef as ReactComponent };